// Importing Main SASS File
import "../scss/app/app.scss";

import "./inc/front_nav";

import "./inc/accordion";

(function ($) {
  "use strict";

  $(".tab-title").on("click", function () {
    var tab_id = $(this).attr("data-tab");

    $(".tab-title").removeClass("active");
    $(".tab").removeClass("active");

    $(this).addClass("active");
    $("#" + tab_id).addClass("active");
  });
})(jQuery);


(function ($) {
  "use strict";
  // Slick JS Settings
  $(".home-slider").slick({
    infinite: true,
    autoplay: true,
    dots: false,
    arrows: false,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
  });



    // Slick JS Settings
    $(".client-carousel-wrapper.slider").slick({
      infinite: true,
      autoplay: true,
      dots: true,
      arrows: true,
      speed: 1200,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerMode: false,
            centerPadding: "50px",
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
          },
        },
  
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            centerPadding: "30px",
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: false,
            centerPadding: "30px",
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
          },
        },
      ],
    });


    $(".testimonials-slider").slick({
      infinite: true,
      autoplay: true,
      dots: true,
      arrows: true,
      speed: 1200,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1366,
          settings: {
            centerMode: false,
            centerPadding: "50px",
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            centerMode: false,
            centerPadding: "50px",
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
          },
        },  
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            centerPadding: "30px",
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
          },
        },
      ],
    });

})(jQuery);